// Desglose del puntaje por variable (Req. 10.7): valor catálogo, valor Discogs,
// similitud, peso y aporte. Se muestra en un panel plegable para no saturar.

import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { VariableBreakdown } from '../types.js';

export function ScoreBreakdown({ breakdown }: { breakdown: VariableBreakdown[] }) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const rows = breakdown.filter((b) => !b.skipped);
  return (
    <>
      <button
        type="button"
        aria-label={open ? t('scoreBreakdown.hide') : t('scoreBreakdown.show')}
        className="w-8 h-8 shrink-0 rounded bg-surface-container text-on-surface-variant flex items-center justify-center active:scale-95 transition-transform"
        onClick={() => setOpen((o) => !o)}
      >
        <span className={`material-symbols-outlined text-[16px] transition-transform ${open ? 'rotate-180' : ''}`}>
          insights
        </span>
      </button>
      {open && (
        <div className="w-full mt-space-xs overflow-x-auto">
          <table className="w-full font-code-catalog text-badge-micro">
            <thead>
              <tr className="text-on-surface-variant uppercase">
                <th className="text-left py-1 pr-2">{t('scoreBreakdown.variable')}</th>
                <th className="text-left py-1 pr-2">{t('scoreBreakdown.catalog')}</th>
                <th className="text-left py-1 pr-2">{t('scoreBreakdown.discogs')}</th>
                <th className="text-right py-1 pr-2">{t('scoreBreakdown.similarity')}</th>
                <th className="text-right py-1 pr-2">{t('scoreBreakdown.weight')}</th>
                <th className="text-right py-1">{t('scoreBreakdown.contribution')}</th>
              </tr>
            </thead>
            <tbody className="text-on-surface">
              {rows.map((b) => (
                <tr key={b.field} className="border-t border-border-subtle">
                  <td className="py-1 pr-2">{b.field}</td>
                  <td className="py-1 pr-2 text-on-surface-variant">{b.catalogValue ?? '—'}</td>
                  <td className="py-1 pr-2 text-on-surface-variant">{b.discogsValue ?? '—'}</td>
                  <td className="py-1 pr-2 text-right">{(b.similarity * 100).toFixed(0)}%</td>
                  <td className="py-1 pr-2 text-right">{(b.weight * 100).toFixed(0)}%</td>
                  <td className="py-1 text-right text-primary">{b.contribution.toFixed(1)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
}
